import classnames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl/FormattedMessage';
import type { IntlKey } from 'locales';
import { FC, useMemo } from 'react';

interface ErrorTooltipBodyProps {
  messages?: readonly string[];
}

export const ErrorTooltipBody: FC<ErrorTooltipBodyProps> = ({ messages = [] }) => {
  const formattedMessages = useMemo(() => {
    return messages.map(msg => msg.split('\r\n'));
  }, [messages]);

  return formattedMessages.length === 0 ? null : (
    <div data-e2e="tooltip-body" className="text-start text-primary fs-6 px-2 pt-2">
      {formattedMessages.map((msg, index) => (
        <div
          className={classnames({
            'mt-2': index !== 0,
          })}
          data-e2e="tooltip-message"
          key={index}
        >
          {msg.map(line => (
            <div data-e2e="tooltip-message-line" key={line}>
              <FormattedMessage id={line as IntlKey} defaultMessage={line} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
